export default __webpack_public_path__ + "static/thumb-landscape-667220755058f627b59f5a0fc67e089a.jpg";